import React from 'react';
import Four01kCalculator from '../components/calculators/401kCalculator';
import FAQ from '../components/FAQ';
import SEO from '../components/shared/SEO';

const Four01kPage: React.FC = () => {
  const faqs = [
    {
      question: "What is a 401(k)?",
      answer: "A 401(k) is an employer-sponsored retirement plan that allows you to contribute pre-tax dollars from your paycheck for retirement savings."
    },
    {
      question: "How does employer matching work?",
      answer: "Employer matching is when your company contributes additional money to your 401(k) based on your contributions. For example, a 50% match up to 6% means they'll contribute 50 cents for every dollar you contribute, up to 6% of your salary."
    },
    {
      question: "What are the contribution limits?",
      answer: "For 2024, the maximum employee contribution limit is $23,000. If you're 50 or older, you can make additional catch-up contributions of $7,500."
    },
    {
      question: "Should I contribute more than the match?",
      answer: "It's generally recommended to at least contribute enough to get the full employer match, as this is essentially free money. Beyond that, consider your other financial goals and retirement needs."
    },
    {
      question: "What aren't included in these calculations?",
      answer: "This calculator doesn't account for potential salary increases, changes in contribution limits, vesting schedules, or tax implications. Consult with a financial advisor for personalized advice."
    }
  ];

  return (
    <>
      <SEO 
        title="401(k) Retirement Calculator"
        description="Calculate your 401(k) retirement savings with employer match benefits. Project your retirement savings and optimize contributions."
        keywords={[
          '401k calculator',
          'retirement planning',
          'employer match',
          '401k contributions',
          'retirement savings',
          '401k benefits',
          'retirement account',
          '401k projection',
          'retirement planning tool',
          'employer benefits'
        ]}
      />
      <Four01kCalculator />
      <FAQ faqs={faqs} />
    </>
  );
};

export default Four01kPage;